(() => {
  const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, '');
  const init = () => {
    document.querySelectorAll('[data-fb-directory]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const filter = root.querySelector('[data-fb-filter]');
      const input = filter.querySelector('input');
      const entries = [...root.querySelectorAll('[data-fb-entry]')];
      filter.hidden = false;
      const update = () => {
        const query = normalize(input.value.trim());
        let visible = 0;
        entries.forEach(entry => { entry.hidden = !normalize(entry.dataset.name).includes(query); if (!entry.hidden) visible++; });
        root.querySelector('[data-fb-directory-count]').textContent = `${visible} ${visible === 1 ? 'collection' : 'collections'}${query ? ' found' : ' to explore'}`;
        root.querySelector('[data-fb-directory-empty]').hidden = visible !== 0;
      };
      input.addEventListener('input', update);
      update();
    });
    document.querySelectorAll('[data-fb-recommendations]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const pool = [...root.querySelectorAll('template[data-fb-pick]')];
      const grid = root.querySelector('[data-fb-picks]');
      const button = root.querySelector('[data-fb-shuffle]');
      let history = [];
      try { const stored = JSON.parse(sessionStorage.getItem('fb-picks-v1') || '[]'); if (Array.isArray(stored)) history = stored.filter(id => typeof id === 'string').slice(-40); } catch (_) { /* Storage is optional. */ }
      let current = [];
      const shuffle = items => {
        const result = [...items];
        for (let i = result.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [result[i], result[j]] = [result[j], result[i]]; }
        return result;
      };
      const show = (initial = false) => {
        const fresh = pool.filter(item => !history.includes(item.dataset.fbPick) && !current.includes(item.dataset.fbPick));
        let ordered = initial && history.length === 0 ? pool : shuffle(fresh);
        ordered = [...ordered, ...shuffle(pool.filter(item => !current.includes(item.dataset.fbPick))), ...pool];
        const chosen = [...new Map(ordered.map(item => [item.dataset.fbPick, item])).values()].slice(0, 4);
        current = chosen.map(item => item.dataset.fbPick);
        grid.replaceChildren(...chosen.map(item => item.content.cloneNode(true)));
        root.dataset.selected = current.join(',');
        history = [...history, ...current].slice(-40);
        try { sessionStorage.setItem('fb-picks-v1', JSON.stringify(history)); } catch (_) { /* No effect on shopping. */ }
        if (!initial) root.querySelector('[data-fb-picks-status]').textContent = 'New picks are ready. Explore the products above.';
      };
      show(true);
      if (button) { button.hidden = false; button.addEventListener('click', () => show()); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
